import A from "@cobasi/ds-icons/solid/a";
import B from "@cobasi/ds-icons/solid/b";
import C from "@cobasi/ds-icons/solid/c";
import D from "@cobasi/ds-icons/solid/d";
import E from "@cobasi/ds-icons/solid/e";
import F from "@cobasi/ds-icons/solid/f";
import G from "@cobasi/ds-icons/solid/g";
import H from "@cobasi/ds-icons/solid/h";
import I from "@cobasi/ds-icons/solid/i";
import J from "@cobasi/ds-icons/solid/j";
import K from "@cobasi/ds-icons/solid/k";
import L from "@cobasi/ds-icons/solid/l";
import M from "@cobasi/ds-icons/solid/m";
import N from "@cobasi/ds-icons/solid/n";
import O from "@cobasi/ds-icons/solid/o";
import P from "@cobasi/ds-icons/solid/p";
import Q from "@cobasi/ds-icons/solid/q";
import R from "@cobasi/ds-icons/solid/r";
import S from "@cobasi/ds-icons/solid/s";
import T from "@cobasi/ds-icons/solid/t";
import U from "@cobasi/ds-icons/solid/u";
import V from "@cobasi/ds-icons/solid/v";
import W from "@cobasi/ds-icons/solid/w";
import X from "@cobasi/ds-icons/solid/x";
import Y from "@cobasi/ds-icons/solid/y";
import Z from "@cobasi/ds-icons/solid/z";

import type { IconMapProps } from "./indexedList.types";

const iconMap: IconMapProps = {
  a: A,
  b: B,
  c: C,
  d: D,
  e: E,
  f: F,
  g: G,
  h: H,
  i: I,
  j: J,
  k: K,
  l: L,
  m: M,
  n: N,
  o: O,
  p: P,
  q: Q,
  r: R,
  s: S,
  t: T,
  u: U,
  v: V,
  w: W,
  x: X,
  y: Y,
  z: Z
};

export { iconMap };
